import { render, staticRenderFns } from "./DtcpAccelerometerModuleMeasurementEditDialog.vue?vue&type=template&id=048af1e9&"
import script from "./DtcpAccelerometerModuleMeasurementEditDialog.vue?vue&type=script&lang=ts&"
export * from "./DtcpAccelerometerModuleMeasurementEditDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
